import React, { Component } from "react";

import BiaxialLineChart from "./BiaxialLineChart.js";

class Terminate extends Component {
    render() {
        if (this.props.chartData == null) {
            return (
                <div className="card">
                    <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                        <h4 className="card-header-title">해지</h4>
                    </div>
                    <div className="card-body" style={{ height: this.props.height + "px", textAlign: "center", paddingTop: "50px" }}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </div>
            );
            // } else if(this.props.chartData.length == 0) {
            //     return(
            //         <div className="card border-top border-3 border-top-danger">
            //             <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
            //                 <h5 className="card-header-title">해지</h5>
            //             </div>
            //             <div className="card-body" style={{height: this.props.height+ "px"}}>
            //                 No Data
            //             </div>
            //         </div>
            //     )
        } else {
            return (
                <div className="card">
                    <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                        <h4>{`해지 - ${this.props.bizYear ? this.props.bizYear + "년" : "-"}`}</h4>
                    </div>
                    <div className="card-body" style={{ height: this.props.height + "px" }}>
                        <BiaxialLineChart data={this.props.chartData} />
                    </div>
                </div>
            );
        }
    }
}

export default Terminate;
